import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "*",
      redirect: "/"
    },
    {
      path: "/",
      name: "PageView",
      component: resolve => require(["@/view/PageView"], resolve),
      children: [
        {
          path: "/",
          redirect: "/home"
        },
        {
          path: "/home",
          name: "home",
          component: resolve => require(["@/view/HomePage"], resolve),
          meta: {
            title: "首页"
          }
        },
        {
          path: "/advanceBatch",
          name: "advanceBatch",
          component: resolve => require(["@/view/AdvanceBatch"], resolve),
          meta: {
            title: "提前批类型"
          },
          children: [
            {
              path: "/advanceBatch",
              redirect: "/advanceBatch/junxiao"
            },
            {
              path: "/advanceBatch/junxiao",
              name: "advanceBatch/junxiao",
              component: resolve => require(["@/view/Junxiao"], resolve),
              meta: {
                title: "软件产品丨军事类院校"
              }
            },
            {
              path: "/advanceBatch/jingxiao",
              name: "advanceBatch/jingxiao",
              component: resolve => require(["@/view/Jingxiao"], resolve),
              meta: {
                title: "公安类院校"
              }
            },
            {
              path: "/advanceBatch/directedSergeant",
              name: "advanceBatch/directedSergeant",
              component: resolve =>
                require(["@/view/directedSergeant"], resolve),
              meta: {
                title: "定向士官院校"
              }
            }
          ]
        },
        {
          path: "/service",
          name: "service",
          component: resolve => require(["@/view/Service"], resolve),
          meta: {
            title: "相关产品"
          }
        },
        {
          path: "/newsinformation",
          name: "newsinformation",
          component: resolve => require(["@/view/NewsInformation"], resolve),
          meta: {
            title: "新闻动态"
          }
        },
        // {
        //   path: "/companyintroduction",
        //   name: "companyintroduction",
        //   component: resolve =>
        //     require(["@/view/CompanyIntroduction"], resolve),
        //   meta: {
        //     title: "公司介绍"
        //   }
        // },
        {
          path: "/contactus",
          name: "contactus",
          component: resolve => require(["@/view/ContactUs"], resolve),
          meta: {
            title: "联系我们"
          }
        },
        {
          path: "/servicedetail",
          name: "servicedetail",
          component: resolve => require(["@/view/ServiceDetail"], resolve),
          meta: {
            title: "相关产品"
          }
        },
        {
          path: "/WebOwnership",
          name: "WebOwnership",
          component: resolve => require(["@/view/WebOwnership"], resolve),
          meta: {
            title: "相关产品"
          }
        },
        {
          path: "/loncon",
          name: "loncon",
          component: resolve => require(["@/view/loncon"], resolve),
          meta: {
            title: "独立信息"
          }
        },
        {
          path: "/junPlan",
          name: "junPlan",
          component: resolve => require(["@/view/junPlan"], resolve),
          meta: {
            title: "军校招生计划"
          }
        },
        {
          path: "/jingPlan",
          name: "jingPlan",
          component: resolve => require(["@/view/jingPlan"], resolve),
          meta: {
            title: "警校招生计划"
          }
        },
        {
          path: "/junShiPlan",
          name: "junShiPlan",
          component: resolve => require(["@/view/junShiPlan"], resolve),
          meta: {
            title: "军士招生计划"
          }
        },
        {
          path: "/oneForOne",
          name: "one",
          component: resolve => require(["@/view/one"], resolve),
          meta: {
            title: "一对一"
          }
        },
        {
          path: "/junFraction",
          name: "junFraction",
          component: resolve => require(["@/view/junFraction"], resolve),
          meta: {
            title: "军校录取分数"
          }
        },
        {
          path: "/jingFraction",
          name: "jingFraction",
          component: resolve => require(["@/view/jingFraction"], resolve),
          meta: {
            title: "2023年警校录取分数"
          }
        }
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js